export const SHOW_PROGRESS = "SHOW_PROGRESS";
export const HIDE_PROGRESS = "HIDE_PROGRESS";

export const showProgress = () => ({
  type: SHOW_PROGRESS,
});

export const hideProgress = () => ({
  type: HIDE_PROGRESS,
});
